export enum DeleteReason {
	COMPLIANCE = 'COMPLIANCE',
	PII_DATA = 'PII_DATA',
	INACCURATE_DATA = 'INACCURATE_DATA',
	OLD_DATA = 'OLD_DATA',
	TEST_DATA = 'TEST_DATA',
	OTHER = 'OTHER',
}
